import { render, staticRenderFns } from "./discount-campaign-list.vue?vue&type=template&id=517dd7b4"
import script from "./discount-campaign-list.ts?vue&type=script&lang=js&external"
export * from "./discount-campaign-list.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports